import * as React from "react";
import { Row, Col, InputGroup, Dropdown } from "react-bootstrap";
import { SearchIcon } from "../../../../components/ui/icons";
import TableView from "../../../../components/tableView";
import Modal4CreateNewOrgAdmin from "../../../../components/modals/createNewOrgAdmin";
import { DataAvailabilityMessages, routes } from "../../../../common/constants";
import DebouncedInput from "../../../../components/tableView/debouncedInput";
import useOrganizations from "./useOrganizations";
import "../../users.scss";
import "../superadminusers.scss";
import UpdteFirmwareVersion from "../../../../components/modals/updateFIrmwareVersion";
import UpdteIotAgentVersion from "../../../../components/modals/udpateIotAgentVersion";
import AssignTemplatesModal from "../../../../components/superAdmin/AssignTemplatesModal";

const Organizations = () => {
  const {
    organizationsTableData,
    organizationsColumns,
    globalFilter,
    setGlobalFilter,
    showFirmware,
    showIotAgent,
    showAssignTemplates,
    setShowAssignTemplates,
    assignOrgId,
  } = useOrganizations();

  return (
    <>
      <div className="admin-users-container superadmin_users_container">
        <Col>
          <div className="dm-heading-container">
            <Row>
              <Col sm={3}>
                <div className="heading">Organizations</div>
              </Col>
              <Col sm={9}>
                <div className="users-add-role-container">
                  <div className="user-search-input">
                    <InputGroup>
                      <DebouncedInput
                        value={globalFilter ?? ""}
                        onChange={(value) => setGlobalFilter(String(value))}
                        placeholder="Search"
                        aria-describedby="organization-search"
                      />
                      <InputGroup.Text id="organization-search">
                        <SearchIcon />
                      </InputGroup.Text>
                    </InputGroup>
                  </div>
                  <div className="user-add-role-btn">
                    <Modal4CreateNewOrgAdmin />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
        <Col>
          <div className="dm-body">
            <Row>
              <Col sm={12}></Col>
              <Col sm={12}>
                <div className="dm-table-container-organizations">
                  <TableView
                    data={organizationsTableData}
                    columns={organizationsColumns}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    noDataMessage={DataAvailabilityMessages.NO_USER_AVAILABLE}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </div>
      {showFirmware && (
        <UpdteFirmwareVersion show={showFirmware}></UpdteFirmwareVersion>
      )}
      {showIotAgent && (
        <UpdteIotAgentVersion show={showIotAgent}></UpdteIotAgentVersion>
      )}
      {showAssignTemplates && (
        <AssignTemplatesModal
          show={showAssignTemplates}
          orgId={assignOrgId}
          onClose={() => setShowAssignTemplates(false)}
        />
      )}
    </>
  );
};

export default Organizations;
